const AppConfig = {
  isDevelopment: process.env.NODE_ENV === "Production",
  baseUrl: "https://www.vecabo.com",
  sagaUrl: process.env.NODE_ENV === "development" ?
    "http://localhost:5000/api" :
    "https://api.vecabo.com/api",
  // sagaUrl: "https://api.vecabo.com/api",
  dateTimeFormat: "yyyy-mm-dd HH:MM:ss",
  dateFormat: "L",
  timeFormat: "HH:MM a",
  datesFormat: "Do",
  monthFormat: "MMMM ",
  yearFormat: "YYYY ",
  resourceContentUrl: "https://source.vecabo.com/content",
  defaultLanguage: "th",
  enabledLanguages: [
    { name: "langSwitcher.en", code: "en" },
    { name: "langSwitcher.th", code: "th" }
  ],
  facebook: {
    appId: "610560326510314", // link to tech@vecabo.com
    pageUrl: "https://www.facebook.com/vecabotrans/",
    pageId: "1981466522084030" // recheck if this link to vecabotrans
  },
  google: {
    clientId:
      "250661362677-7pob7ihnfe0mh7r13ei8n957l1j4f6em.apps.googleusercontent.com"
  },
  vat: 7,
  percent: 50
}

export default AppConfig



// WEBPACK FOOTER //
// ./src/configs/AppConfig.ts